module.exports = __webpack_public_path__ + "static/media/HCMM159.853a38b6.jpg";